/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import React from "react";
import QuickPanelMain from "./Main.helper";

export function QuickPanel() {
  return <QuickPanelMain />;
}
